// extracted by mini-css-extract-plugin
export default {"homePageBlock":"HomePageblock_homePageBlock__27CGe","homePageBlockImage":"HomePageblock_homePageBlockImage__AS8yf","homePageBlockText":"HomePageblock_homePageBlockText__Elex9"};